// extracted by mini-css-extract-plugin
export default {"App":"App_App__U1Z2v","App-logo":"App_App-logo__7bpEi","App-logo-spin":"App_App-logo-spin__8RjMD","App-header":"App_App-header__d-Gqb","App-link":"App_App-link__ZYuRb"};